import {AlertColor} from '@logistics-frontend/blocks/legacy'
import {createContext, Dispatch, useContext} from 'react'

export type Notification = {
  type?: 'alert' | 'snackbar'
  severity?: AlertColor
  message: string
}

export type State = Notification[]
export type Action = {type: 'add'; payload: Notification} | {type: 'remove'; payload: Notification}
export type Context = [State, Dispatch<Action>]

export const NotificationsContext = createContext<Context | null>(null)
export const useNotificationsContext = (): Context => {
  const contextValue = useContext(NotificationsContext)

  if (contextValue === null) {
    throw new Error('missing <NotificationsProvider/>')
  }

  return contextValue
}
